<template>
  <div class="cert-header d-flex py-5">
    <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
      <div class="cert-title cert-large">Tools</div>
    </div>
  </div>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-2 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
    <div class="">
      <cert-data-card title="Nessus"
                      data="Nessus is a network vulnerability scanner that uses the Common Vulnerabilities and Exposures architecture for easy cross-linking between compliant security tools."
                      link="tenable.com/products/nessus" class="my-3"/>
      <cert-data-card title="Nikto"
                      data="Nikto is an open source web server and web application scanner. Nikto can perform comprehensive tests against web servers for multiple security threats and can also perform checks for outdated web server’s software, and version-specific problems."
                      link="kali.org/tools/nikto/" class="my-3"/>
      <cert-data-card title="Nmap"
                      data="Nmap allows you to scan your network and discover not only everything connected to it, but also a wide variety of information about what's connected, what services each host is operating."
                      link="nmap.org/" class="my-3"/>
      <cert-data-card title="Shodan"
                      data="Shodan (Sentient Hyper-Optimised Data Access Network) is a search engine designed to map and gather information about internet-connected devices and systems."
                      link="shodan.io/" class="my-3"/>
      <cert-data-card title="OWASP Zap"
                      data="Zed Attack Proxy (ZAP) is a free, open-source penetration testing tool being maintained under the umbrella of the Open Web Application Security Project (OWASP). ZAP is designed specifically for testing web applications and is both flexible and extensible."
                      link="owasp.org/www-project-zap/" class="my-3"/>
      <cert-data-card title="HitmanPro"
                      data="HitmanPro is a lightweight tool to clean and remove malware, viruses, Trojans, adware, spyware and ransomware."
                      link="hitmanpro.com/" class="my-3"/>
      <cert-data-card title="SpyHunter"
                      data="SpyHunter is a Windows application designed to scan for, identify, remove and block malware, potentially unwanted programs (PUPs) and other objects."
                      link="spyhunter.com/" class="my-3"/>
      <cert-data-card title="SysInternal tools"
                      data="The SysInternals suite of tools is simply a set of Windows applications that offers technical resources and utilities to manage, diagnose, troubleshoot, and monitor a Microsoft Windows environment."
                      link="docs.microsoft.com/en-us/sysinternals/downloads/" class="my-3"/>
      <cert-data-card title="VirusTotal"
                      data="Virus Total is an online service that analyzes suspicious files and URLs to detect types of malware and malicious content using antivirus engines and website scanners. It provides an API that allows users to access the information generated by VirusTotal."
                      link="virustotal.com/gui/home/upload" class="my-3"/>
      <cert-data-card title="SSL Labs"
                      data="This free online service performs a deep analysis of the configuration of any SSL web server on the public Internet."
                      link="ssllabs.com/" class="my-3"/>
      <cert-data-card title="MXtoolbox"
                      data="MxToolbox supports global Internet operations by providing free, fast and accurate network diagnostic and lookup tools."
                      link="mxtoolbox.com/" class="my-3"/>
      <cert-data-card title="Wireshark"
                      data="Wireshark is the world’s foremost and widely-used network protocol analyzer. It lets you see what’s happening on your network at a microscopic level and is the de facto (and often de jure) standard across many commercial and non-profit enterprises, government agencies, and educational institutions."
                      link="wireshark.org/" class="my-3"/>

    </div>
  </div>
</template>

<script>
import CertDataCard from './components/CertDataCard';

export default {
  name: "Tools",
  components: {
    CertDataCard,
  },
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
  }
}
</script>
